import React from 'react';
import './ChapterVolumeHeader.scss';
import ProductPoster from '../KodanshaUIKit/ProductPoster/ProductPoster';
import { Product } from '../../Models/Product';
import { readerReadableUrlOrDefault } from '../../utils/utils';

const ChapterVolumeHeader = ({volume, childAsRenderedProps, isSelected, isOwned }: {volume: Product; childAsRenderedProps: JSX.Element[]; isSelected: boolean;
    isOwned: boolean;}): JSX.Element => {
//TODO: READER uses readable url
    return (
        <div className='volume-container'>

            <div className={isSelected ? 'volume-info selected' : 'volume-info'} onClick={(e): void => {
                e.preventDefault();
                // Navigate to volume
                window.location.href = readerReadableUrlOrDefault(volume);
            }
            }>
                <div className={'volume-thumbnail'}>
                    <ProductPoster src={volume.thumbnails[0].url}  />
                </div>
                <div className={'volume-title-wrapper'}>
                    <div className={'volume-title'}>
                        <p>{volume.name}</p>
                    </div>
                    {isOwned && (
                        <div className={'volume-label'}>
                            <p>In Library</p>
                        </div>
                    )}
                </div>

            </div>



            <div className='volume-children-wrapper'>
                {childAsRenderedProps}
                <div className={'volume-spacer'}></div>
            </div>
        </div>
    );
};

export default ChapterVolumeHeader;
